@if variable-exists(isWidget) and $isWidget == false {
  .darkMode {
    // color - legacy v1.119.0
    $text-color-map: (
      // legacy v1.119.0
      "primary":
        #f0f2f5,
      // legacy v1.119.0
      "secondery":
        #89969f,
      // legacy v1.119.0
      "light-primary":
        #3e77b2
    );
    @each $name, $color in $text-color-map {
      .text-color-#{$name} {
        color: $color;
      }
    }

    // btn color
    $btn-colors: (
      "primary": #82c0f7,
      "primary-active": #3e77b2,
      "secondery": #6fa3d2,
      "main-primary": #f0f2f5,
      "main-secondary": #000716,
      "neutral-primary": #89969f,
      "neutral-secondary": #363d41,
      "neutral-tertiary": #2d3941,
      "brand-primary": #3e77b2,
      "brand-secondary": #6fa3d2,
      "brand-tertiary": #ffffff,
      "brand-alt": #ffffff,
      "error-primary": #bc2e3f,
      "error-secondary": #844855,
      "yellow": #d6a430,
      "green": #265b4c,
      "none": transparent,
    );
    @each $name, $btn-color in $btn-colors {
      .button-bg-#{$name} {
        background-color: $btn-color;
        @if ($name == none) {
          width: fit-content !important;
          min-width: unset !important;
          padding: 0 0;
          &:hover {
            background-color: $btn-color;
          }
        }
      }
    }
    // color
    $colors: (
      // legacy v1.119.0
      "primary":
        #f0f2f5,
      // legacy v1.119.0
      "secondery":
        #2d3941,
      // legacy v1.119.0
      "light":
        #f0f2f51c,
      // legacy v1.119.0
      "light-dark":
        #89969f,
      // legacy v1.119.0
      "white":
        #fff,
      // legacy v1.119.0
      "input":
        #000716,
      // legacy v1.119.0
      "disabled-input":
        #1c272e,
      // legacy v1.119.0
    );
    @each $name, $color in $colors {
      .color-#{$name} {
        color: $color;
      }

      .bc-#{$name} {
        border-color: $color !important;
        border: solid 1px;
      }

      .bg-color-#{$name} {
        background-color: $color;
      }

      .outline-#{$name}:focus {
        outline: solid $color;
      }
    }

    .datePickerContainer {
      box-shadow: 0px 15px 18px rgba(0, 0, 0, 0.6) !important;
    }

    .bg-color-main-secondary {
      :global {
        .MuiCalendarPicker-root {
          .MuiTypography-caption {
            color: #89969f;
          }
        }
      }

      .mui-calendar-day-color {
        color: #f0f2f5;
        background-color: #000716;
        font-family:
          "Galano Grotesque",
          Segoe UI,
          sans-serif;
        &:not(:global .MuiPickersDay-today, .Mui-selected) {
          &:hover {
            background-color: transparent !important;
          }
        }
        &:hover {
          border: solid 1px #89969f !important;
        }
      }

      .mui-out-of-month {
        color: #89969f;
      }

      .mui-calendar-today {
        background-color: #3e77b2 !important;
        color: #f0f2f5;
        border: unset !important;
      }

      .mui-calendar-selected {
        background-color: #2d3941 !important;
        color: #f0f2f5 !important;

        &:focus {
          background-color: #2d3941 !important;
        }
      }
    }

    // color map dark mode
    $colors-pallete: (
      "main-primary": #f0f2f5,
      "main-secondary": #000716,
      "neutral-primary": #89969f,
      "neutral-secondary": #363d41,
      "neutral-tertiary": #2d3941,
      "brand-primary": #3e77b2,
      "brand-secondary": #6fa3d2,
      "brand-tertiary": #ffffff,
      "brand-alt": #ffffff,
      "error-primary": #bc2e3f,
      "error-secondary": #844855,
      "yellow": #d6a430,
      "green": #265b4c,
      "none": transparent,
    );
    @each $name, $color in $colors-pallete {
      .color-#{$name} {
        color: $color !important;
      }

      .bc-#{$name} {
        border-color: $color !important;
        border: solid 1px;
      }

      .btc-#{$name} {
        border-top-color: $color !important;
        border-top: solid 1px;
      }

      .brc-#{$name} {
        border-right-color: $color !important;
        border-right: solid 1px;
      }

      .bbc-#{$name} {
        border-bottom-color: $color !important;
        border-bottom: solid 1px;
      }

      .blc-#{$name} {
        border-left-color: $color !important;
        border-left: solid 1px;
      }

      .bg-color-#{$name} {
        background-color: $color !important;
      }

      .hover-bg-color-#{$name} {
        transition: background-color 0.25s ease-out;
        &:hover {
          transition: background-color 0.25s ease-in;
          background-color: $color !important;
        }
      }

      .outline-#{$name}:focus {
        outline: solid $color;
      }

      .stroke-#{$name} {
        stroke: $color;
      }

      .hover-color-#{$name} {
        transition: color 0.25s ease-out;
        &:hover {
          transition: color 0.25s ease-in;
          color: $color !important;
        }
      }

      svg,
      a,
      input,
      pre,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      span,
      div,
      button,
      a,
      select,
      option,
      i,
      ul,
      ol,
      li {
        &.dark-mode-color-#{$name} {
          color: $color !important;
        }

        &.dark-mode-bc-#{$name} {
          border-color: $color !important;
          border: solid 1px;
        }

        &.dark-mode-btc-#{$name} {
          border-top-color: $color !important;
          border-top: solid 1px;
        }

        &.dark-mode-brc-#{$name} {
          border-right-color: $color !important;
          border-top: solid 1px;
        }

        &.dark-mode-bbc-#{$name} {
          border-bottom-color: $color !important;
          border-top: solid 1px;
        }

        &.dark-mode-blc-#{$name} {
          border-left-color: $color !important;
          border-top: solid 1px;
        }

        &.dark-mode-bg-color-#{$name} {
          background-color: $color !important;
        }

        &.dark-mode-hover-bg-color-#{$name} {
          transition: background-color 0.25s ease-out;
          &:hover {
            transition: background-color 0.25s ease-in;
            background-color: $color !important;
          }
        }

        &.dark-mode-hover-color-#{$name} {
          transition: color 0.25s ease-out;
          &:hover {
            transition: color 0.25s ease-in;
            color: $color !important;
          }
        }

        &.dark-mode-outline-#{$name}:focus {
          outline: solid $color;
        }

        &.dark-mode-stroke-#{$name} {
          stroke: $color;
        }

        &.dark-mode-hover-color-#{$name} {
          transition: color 0.25s ease-out;
          &:hover {
            transition: color 0.25s ease-in;
            color: $color !important;
          }
        }
      }
    }

    .hover-parent {
      @each $name, $color in $colors-pallete {
        .hover-child-bg-color-#{$name} {
          transition: background-color 0.25s ease-out;
        }

        &.dark-mode-hover-child-bg-color-#{$name} {
          transition: background-color 0.25s ease-out;
        }

        &:hover {
          .hover-child-bg-color-#{$name} {
            transition: background-color 0.25s ease-in;
            background-color: $color !important;
          }

          svg,
          a,
          input,
          pre,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          p,
          span,
          div,
          button,
          a,
          select,
          option,
          i,
          ul,
          ol,
          li {
            .dark-mode-hover-child-bg-color-#{$name} {
              transition: background-color 0.25s ease-in;
              background-color: $color !important;
            }
          }
        }
      }
    }

    $switch-color-map: (
      "background": #89969f,
      "circle": #f0f2f5,
      "background-active": #0b95ad,
      "icon": #0b95ad,
      "off-text": #363d41,
      "on-text": #f0f2f5,
    );

    @each $name, $color in $switch-color-map {
      .switch-#{$name}-bg-color {
        background-color: $color;
      }
      .switch-#{$name}-color {
        color: $color;
      }
    }

    .dark-mode-remove-border {
      border: unset;
    }
  }

  // border-radius map
  $border-radius: (
    "none": 0,
    "extra-small": 4px,
    "small": 8px,
    "default": 12px,
    "large": 24px,
    "extra-large": 48px,
  );
  @each $name, $radius in $border-radius {
    .br-#{$name} {
      border-radius: $radius;
    }
  }

  // fonst-size map
  $font-size: (
    "tiny": 10px,
    "extra-small": 12px,
    "small": 14px,
    "default": 16px,
    "medium": 18px,
    "large": 20px,
    "extra-large": 24px,
    "giant": 36px,
  );
  @each $name, $size in $font-size {
    .fs-#{$name} {
      font-size: $size;
    }
  }

  // display map
  $display-map: (
    "flex": flex,
    "block": block,
  );
  @each $name, $display in $display-map {
    .d-#{$name} {
      display: $display;
    }
  }

  // display direction map
  $flex-direction-map: (
    "row": row,
    "column": column,
  );
  @each $name, $direction in $flex-direction-map {
    .flex-#{$name} {
      flex-direction: $direction;
    }
  }

  // padding inline
  $padding-inline: (
    "extra-small": 8px,
    "small": 12px,
    "default": 24px,
    "large": 36px,
    "extra-large": 48px,
    "giant": 60px,
    "extra-giant": 84px,
    "none": 0px,
  );
  @each $name, $padding in $padding-inline {
    .pi-#{$name} {
      padding-left: $padding;
      padding-right: $padding;
      width: unset;
      box-sizing: border-box;
    }
  }

  // padding y
  $padding-y: (
    "extra-small": 8px,
    "small": 12px,
    "default": 24px,
    "large": 36px,
    "extra-large": 48px,
    "giant": 60px,
    "extra-giant": 84px,
    "none": 0px,
  );
  @each $name, $padding in $padding-inline {
    .py-#{$name} {
      padding-top: $padding;
      padding-bottom: $padding;
      box-sizing: border-box;
    }
  }

  // padding map
  $padding: (
    "extra-small": 4px,
    "small": 6px,
    "default": 12px,
    "large": 24px,
    "extra-large": 36px,
    "none": 0px,
  );
  @each $name, $padding in $padding {
    .p-#{$name} {
      padding: $padding;
      box-sizing: border-box;
    }

    .pt-#{$name} {
      padding-top: $padding;
      box-sizing: border-box;
    }

    .pb-#{$name} {
      padding-bottom: $padding;
      box-sizing: border-box;
    }

    .pr-#{$name} {
      padding-right: $padding;
      box-sizing: border-box;
    }

    .pl-#{$name} {
      padding-left: $padding;
      box-sizing: border-box;
    }
  }

  // margin
  $margin: (
    "extra-small": 8px,
    "small": 12px,
    "default": 24px,
    "large": 36px,
    "extra-large": 48px,
    "giant": 60px,
    "extra-giant": 84px,
    "none": 0px,
  );
  @each $name, $margin in $margin {
    .mt-#{$name} {
      margin-top: $margin;
    }

    .mr-#{$name} {
      margin-right: $margin;
    }

    .mb-#{$name} {
      margin-bottom: $margin;
    }

    .ml-#{$name} {
      margin-left: $margin;
    }

    .m-#{$name} {
      margin: $margin;
    }
  }

  // font-weight map
  $font-weight: (
    "thin": 400,
    "default": 500,
    "bold": 600,
    "bolder": 700,
  );
  @each $name, $weight in $font-weight {
    .fw-#{$name} {
      font-weight: $weight;
    }
  }

  $colors: (
    "primary": #142f43,
    "light-primary": #3e77b2,
    "secondery": #667885,
    "danger": #dc3545,
    "warning": #d9384b,
    "info": #dc3545,
    "light": #f0f2f5,
    "light-dark": #d8dde3,
    "white": white,
    "dark": #212529,
    "success": #198754,
    "unset": unset,
  );
  @each $name, $color in $colors {
    .color-#{$name} {
      color: $color;
    }

    .bc-#{$name} {
      border-color: $color !important;
      border: solid 1px;
    }

    .bg-color-#{$name} {
      background-color: $color;
    }

    .hover-bg-color-#{$name} {
      transition: background-color 0.25s;

      &:hover {
        transition: background-color 0.25s;
        background-color: $color;
      }
    }

    .outline-#{$name}:focus {
      outline: solid $color;
    }
  }

  // color map
  $colors-pallete: (
    "main-primary": #142f43,
    "main-secondary": #ffffff,
    "neutral-primary": #667885,
    "neutral-secondary": #d8dde3,
    "neutral-tertiary": #f0f2f5,
    "brand-primary": #82c0f7,
    "brand-secondary": #e2f1ff,
    "brand-tertiary": #3e77b2,
    "brand-alt": #6fa3d2,
    "error-primary": #d92736,
    "error-secondary": #fadcdc,
    "yellow": #f6c758,
    "green": #dcf7c5,
    "none": transparent,
  );
  @each $name, $color in $colors-pallete {
    .color-#{$name} {
      color: $color !important;
    }

    .bc-#{$name} {
      border-color: $color !important;
      border: solid 1px;
    }

    .btc-#{$name} {
      border-top-color: $color !important;
      border-top: solid 1px;
    }

    .brc-#{$name} {
      border-right-color: $color !important;
      border-right: solid 1px;
    }

    .bbc-#{$name} {
      border-bottom-color: $color !important;
      border-bottom: solid 1px;
    }

    .blc-#{$name} {
      border-left-color: $color !important;
      border-left: solid 1px;
    }

    .bg-color-#{$name} {
      background-color: $color;
    }

    .hover-bg-color-#{$name} {
      transition: background-color 0.25s ease-out;
      &:hover {
        transition: background-color 0.25s ease-in;
        background-color: $color !important;
      }
    }

    .hover-color-#{$name} {
      transition: color 0.25s ease-out;
      &:hover {
        transition: color 0.25s ease-in;
        color: $color !important;
      }
    }

    .outline-#{$name}:focus {
      outline: solid $color;
    }

    .stroke-#{$name} {
      stroke: $color;
    }
  }

  .hover-parent {
    @each $name, $color in $colors-pallete {
      .hover-child-bg-color-#{$name} {
        transition: background-color 0.25s ease-out;
      }
      &:hover {
        .hover-child-bg-color-#{$name} {
          transition: background-color 0.25s ease-in;
          background-color: $color;
        }
      }
    }
  }

  $switch-color-map: (
    "background": #d8dde3,
    "circle": white,
    "background-active": #142f43,
    "icon": #142f43,
    "off-text": #667885,
    "on-text": #ffffff,
  );

  @each $name, $color in $switch-color-map {
    .switch-#{$name}-bg-color {
      background-color: $color;
    }
    .switch-#{$name}-color {
      color: $color;
    }
  }

  .outline-none:focus {
    outline: none;
  }

  // border-radius map
  $outline-width: (
    "default": 1px,
    "medium": 2px,
    "large": 3px,
    "extra-large": 4px,
  );
  @each $name, $width in $outline-width {
    .outline-width-#{$name}:focus {
      outline-width: $width !important;
    }
  }

  // btn color
  $btn-colors: (
    "primary": #82c0f7,
    // legacy
    "primary-active":
      #3e77b2,
    // legacy - 03/10
    "secondery":
      #6fa3d2,
    // legacy - 03/10
    "main-primary":
      #142f43,
    "main-secondary": #ffffff,
    "neutral-primary": #667885,
    "neutral-secondary": #d8dde3,
    // borders color
    "neutral-tertiary":
      #f0f2f5,
    "brand-primary": #82c0f7,
    "brand-secondary": #e2f1ff,
    "brand-tertiary": #3e77b2,
    // links color
    "brand-alt":
      #6fa3d2,
    "error-primary": #d92736,
    "error-secondary": #fadcdc,
    "yellow": #f6c758,
    "green": #dcf7c5,
    "none": transparent,
  );
  @each $name, $btn-color in $btn-colors {
    .button-bg-#{$name} {
      background-color: $btn-color;
      @if ($name == none) {
        width: fit-content !important;
        min-width: unset !important;
        padding: 0 0;
        &:hover {
          background-color: $btn-color;
        }
      }
    }
  }

  // input-size map
  $input-sizes: (
    "small": 45px,
    "default": 50px,
    "large": 60px,
  );
  @each $name, $size in $input-sizes {
    .input-#{$name} {
      height: $size;
    }
  }

  // input-size map
  $select-sizes: (
    "tiny": 20px,
    "extra-small": 30px,
    "small": 45px,
    "default": 50px,
    "large": 60px,
  );
  @each $name, $size in $select-sizes {
    .select-#{$name} {
      min-height: $size;
    }
  }

  // button-size map
  $button-height: (
    "small": 30px,
    "default": 40px,
    "large": 50px,
  );
  @each $name, $size in $button-height {
    .button-height-#{$name} {
      height: $size;
    }
  }

  // text area size map
  $text-area-size: (
    "small": 60px,
    "default": 120px,
    "large": 180px,
    "extra-large": 260px,
  );
  @each $name, $size in $text-area-size {
    .text-area-#{$name} {
      height: $size;
    }
  }

  // checkbox size map
  $check-box-size: (
    "extra-small": 10px,
    "small": 15px,
    "default": 20px,
    "large": 25px,
    "extra-large": 30px,
  );
  @each $name, $size in $check-box-size {
    .check-box-#{$name} {
      min-height: $size;
      min-width: $size;
    }
  }

  // checkbox size map
  $radio-button-size: (
    "extra-small": 10px,
    "small": 16px,
    "default": 20px,
    "large": 24px,
    "extra-large": 30px,
  );
  @each $name, $size in $radio-button-size {
    .radio-button-#{$name} {
      height: $size;
      width: $size;
    }
  }

  $switch-size: (
    "extra-small": 0.5,
    "small": 0.8,
    "default": 1,
    "large": 1.25,
    "extra-large": 1.5,
  );
  @each $name, $size in $switch-size {
    .switch-#{$name} {
      transform: scale($size);
    }
  }

  // border-width map
  $border-width: (
    "default": 1px,
    "medium": 2px,
    "large": 3px,
    "extra-large": 4px,
  );
  @each $name, $width in $border-width {
    .bw-#{$name} {
      border: solid;
      border-width: $width !important;
    }
  }

  // justify-content map
  $justify-content: (
    "start": start,
    "center": center,
    "between": space-between,
    "around": space-around,
    "end": end,
  );
  @each $name, $position in $justify-content {
    .justify-content-#{$name} {
      justify-content: $position;
    }
  }

  $align-items: (
    "baseline": baseline,
    "center": center,
    "flex-end": flex-end,
    "flex-start": flex-start,
    "stretch": stretch,
  );
  @each $name, $position in $align-items {
    .align-items-#{$name} {
      align-items: $position;
    }
  }

  // $text-align map
  $text-align: (
    "start": start,
    "center": center,
    "end": end,
  );
  @each $name, $position in $text-align {
    .text-align-#{$name} {
      text-align: $position;
    }
  }

  // show-hide-border map
  $show-hide-border: (
    "show": solid,
    "hide": none,
  );
  @each $name, $state in $show-hide-border {
    .border-#{$name} {
      border: $state;
    }
  }

  .underLine {
    text-decoration: underline;
  }

  .mui-calendar-day-color {
    color: #142f43;
    font-size: 12px !important;
    font-weight: 500 !important;
    height: 30px !important;
    width: 30px !important;
    font-family:
      "Galano Grotesque",
      Segoe UI,
      sans-serif;
    &:not(:global .MuiPickersDay-today, .Mui-selected) {
      &:hover {
        background-color: transparent !important;
      }
    }
    &:hover {
      border: solid 1px #142f43 !important;
    }
  }

  .mui-calendar-today {
    background-color: #82c0f7 !important;
    border: unset !important;
  }

  .mui-calendar-selected {
    background-color: #e2f1ff !important;
    color: #142f43 !important;
  }

  .bg-color-main-secondary {
    :global {
      .MuiCalendarPicker-root {
        .MuiTypography-caption {
          font-weight: 600;
          color: #667885;
        }
      }
    }
  }

  .disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  .pointer {
    cursor: pointer;
  }

  .text-nowrap {
    white-space: nowrap;
  }
  .form-error {
    .v2ElementContainer {
      border: solid 1px #d9384b !important;
    }
  }
}
